import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { AdminService } from '../../services/api';

const MODELS = [
  ['leads_only', 'Lead Generation Only', 'Patient App leads only. Delivery can use the limited Lead Portal or the separately provisioned vendor API.'],
  ['cms_only', 'Digi Living CMS Only', 'Only subscribed Digi Living operational modules are available. Patient lead generation is not included.'],
  ['hybrid', 'Lead Generation and CMS', 'Patient App leads plus the selected Digi Living CMS modules.'],
];

export default function VendorAccessModal({ vendor, isOpen, onClose, showCustomAlert }) {
  const [model, setModel] = useState('cms_only');
  const [deliveryMode, setDeliveryMode] = useState('cms_module');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!vendor || !isOpen) return;
    AdminService.getVendorAccessModel(vendor.id).then(response => {
      if (response.status === 1 && response.data) {
        const normalized = response.data.business_model === 'api_only' ? 'leads_only' : response.data.business_model;
        setModel(normalized || 'cms_only');
        setDeliveryMode(response.data.lead_delivery_mode || (normalized === 'cms_only' ? 'cms_module' : 'lead_portal'));
      }
    }).catch(error => showCustomAlert?.(error.message));
  }, [vendor, isOpen, showCustomAlert]);

  const chooseModel = value => {
    setModel(value);
    setDeliveryMode(value === 'cms_only' ? 'cms_module' : 'lead_portal');
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const response = await AdminService.updateVendorAccessModel(vendor.id, { business_model: model, lead_delivery_mode: deliveryMode });
      if (response.status !== 1) throw new Error(response.msg || 'Update failed');
      showCustomAlert?.('Vendor access model updated successfully');
      onClose();
    } catch (error) { showCustomAlert?.(error.message); }
    finally { setSaving(false); }
  };

  if (!isOpen || !vendor) return null;
  return <div className="lead-modal-backdrop" onClick={onClose}>
    <div className="lead-modal-content" style={{ maxWidth: 650 }} onClick={event => event.stopPropagation()}>
      <div className="modal-header"><h3>Access Model: {vendor.vendorName || vendor.vendor_name}</h3><button className="close-btn" onClick={onClose}>×</button></div>
      <div className="modal-body" style={{ padding: '1.5rem' }}>
        <p style={{ color: '#64748b', marginTop: 0 }}>Choose the commercial access model here. API credentials and webhook settings are provisioned separately under Vendor API Integrations.</p>
        <div style={{ display: 'grid', gap: '0.75rem' }}>
          {MODELS.map(([value, title, description]) => <label key={value} style={{ display: 'flex', gap: '0.85rem', padding: '1rem', border: model === value ? '2px solid #0284c7' : '1px solid #cbd5e1', background: model === value ? '#f0f9ff' : '#fff', cursor: 'pointer' }}>
            <input type="radio" name="access_model" checked={model === value} onChange={() => chooseModel(value)} />
            <span><strong style={{ display: 'block' }}>{title}</strong><small style={{ color: '#64748b' }}>{description}</small></span>
          </label>)}
        </div>
        {model !== 'cms_only' && <div style={{ marginTop: '1.25rem' }}>
          <label style={{ display: 'block', fontWeight: 700, marginBottom: '0.35rem' }}>Initial lead delivery route</label>
          <select value={deliveryMode} onChange={event => setDeliveryMode(event.target.value)} style={{ width: '100%', padding: '0.65rem' }}>
            <option value="lead_portal">Digi Living Lead Portal</option>
            <option value="api_webhook">Vendor API Integration</option>
            {model === 'hybrid' && <option value="cms_module">Digi Living CMS</option>}
          </select>
          {deliveryMode === 'api_webhook' && <p style={{ color: '#64748b', fontSize: '0.8rem' }}>After saving, complete secure credentials and delivery configuration under Patient Leads Engine → Vendor API Integrations.</p>}
        </div>}
      </div>
      <div className="modal-footer"><button className="btn-secondary" onClick={onClose}>Cancel</button><button className="primary-action-btn" onClick={handleSave} disabled={saving}><Save size={15} /> {saving ? 'Saving...' : 'Apply Model'}</button></div>
    </div>
  </div>;
}
